import useAbsoluteUnits from "@jmc/solid-design-system/src/utils/useAbsoluteUnits";

export const relativeUnitToAbsolute = (unit: string): string => {
    if (useAbsoluteUnits()) {
        switch (unit) {
            case "15vh":
                return "7.5rem";
            case "30vh":
                return "8.125rem";
            case "70vh":
                return "15.625rem";
            case "auto":
            case "45vh":
            default:
                return "11.875rem";
        }
    } else {
        return unit;
    }
};

export default relativeUnitToAbsolute;
